import { Component, OnInit, HostListener } from '@angular/core';
import { ContentfulService } from '../contentful.service';
import { Entry } from 'contentful';
import {ActivatedRoute} from "@angular/router";
import {IAlbum, Lightbox} from 'ngx-lightbox';

@Component({
  selector: 'app-artifact-list',
  templateUrl: './artifact-list.component.html',
  styleUrls: ['./artifact-list.component.scss']
})
export class ArtifactListComponent implements OnInit {
  artifacts: Entry<any>[];
  artifactsForLightBox: IAlbum[];
  columnCount: number = 3;
  containerHeightGraphic: any = '1000px';
  containerHeightLogo: any = '1000px';
  categoryLinkName: string;
 

  constructor(private contentfulService: ContentfulService, private activatedRoute: ActivatedRoute, private _lightbox: Lightbox
    ) { }

  ngOnInit() {

    this.categoryLinkName = this.activatedRoute.snapshot.paramMap.get('categoryid');

    this.contentfulService.getSettings().then(settings => { 
      console.log(this.categoryLinkName);
        this.containerHeightGraphic = settings[0].fields.settings.ContainerHeightGraphic;
        this.containerHeightLogo = settings[0].fields.settings.ContainerHeightLogo;
    });

    if (window && window.innerWidth && window.innerWidth < 700) {
      this.columnCount = 1;
    }

    if (this.categoryLinkName === null) {
      this.contentfulService.getAllArtifacts()
         .then(artifacts => {
           this.handleArtifactData(artifacts);

        });
    }
    else {
      this.contentfulService.getCategories({'fields.linkname': this.categoryLinkName}).then((category) => {
        this.contentfulService.getArtifactsByCategoryId(category[0].sys.id)
           .then(artifacts => {
             this.handleArtifactData(artifacts);
          });
      });
    }
  }

  handleArtifactData = (artifacts) => {
    this.artifacts = artifacts;
   // this.artifacts = this.artifacts.concat(this.artifacts);
    this.artifactsForLightBox = artifacts.map((artifact, index) => {
      return {
        src: artifact.fields.image[0].fields.file.url,
        caption: artifact.fields.productDescription,
        thumb: artifact.fields.image[0].fields.file.url
      }
    });
  };

  open(index: number): void {
    this._lightbox.open(this.artifactsForLightBox, index);
  }

  close(): void {
    this._lightbox.close();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (window && window.innerWidth && window.innerWidth < 700) {
      this.columnCount = 1;
    } else {
      this.columnCount = 3;
    }
  }
}
